import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { AppointmentFormComponent } from "./components/appointment-form/appointment-form.component";
import { BookingListComponent } from "./components/booking-list/booking-list.component";
import { BookingCalendarComponent } from "./components/booking-calendar/booking-calendar.component";
import { BookingReportsComponent } from "./components/booking-reports/booking-reports.component";
import { SalesReportComponent } from "./components/booking-reports/sales-report/sales-report.component";
import { EmployeesReportComponent } from "./components/booking-reports/employees-report/employees-report.component";
import { OperationalReportComponent } from "./components/booking-reports/operational-report/operational-report.component";
import { CalendarModule, DateAdapter } from "angular-calendar";
import { adapterFactory } from "angular-calendar/date-adapters/date-fns";
import { SharedModule } from "../shared/shared.module";
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { UiFormModule } from "../../shared/ui";
import { AppointmentService } from "./services/projects.service";
import { BookingService } from "./services/booking.service";
import { BookingReportsService } from "./services/booking-reports.service";
import { TicketModule } from "../income/ticket";
import { TicketFormV2Component } from "../income/ticket/components/ticket-form/ticket-form.components";
import { LocationsModule } from "./locations/locations.module";
import { BaseChartDirective, provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { ContactService } from "../contacts/services/contact.service";

@NgModule({
    declarations: [
        AppointmentFormComponent,
        BookingListComponent,
        BookingCalendarComponent,
        BookingReportsComponent,
        SalesReportComponent,
        EmployeesReportComponent,
        OperationalReportComponent,
    ],
    exports: [
        AppointmentFormComponent,
        BookingListComponent,
        BookingCalendarComponent,
        BookingReportsComponent,
        SalesReportComponent,
        EmployeesReportComponent,
        OperationalReportComponent,
    ],
    providers: [
        AppointmentService,
        BookingService,
        BookingReportsService,
        provideCharts(withDefaultRegisterables()),
        ContactService // V2: detalle de contacto por uid
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        RouterModule,
        UiFormModule,
        SharedModule,
        FormsModule,
        LocationsModule,
        CalendarModule.forRoot({
            provide: DateAdapter,
            useFactory: adapterFactory,
        }),
        MatInputModule,
        MatFormFieldModule,
        MatButtonModule,
        MatTableModule,
        MatIconModule,
        MatProgressSpinnerModule,
        MatToolbarModule,
        MatCardModule,
        MatDividerModule,
        MatSelectModule,
        MatAutocompleteModule,
        MatDialogModule,
        MatSnackBarModule,
        MatOptionModule,
        MatDatepickerModule,
        
    ]
})
export class BookingModule { }
